import { ApiPostRequest } from 'src/app/model/api/api-request/api-post-request';
import { ClientInfo } from 'src/app/model/interfaces/client-info';
import { PaymentInterval } from '../../../../model/types/payment-interval';

export class RecurringUpsaleRequest extends ApiPostRequest
{
    public constructor(
        playerId: number,
        ticketNumber: number,
        ticketLetter: string,
        classCount: PaymentInterval,
        regNumber: number,
        accountnumber: number,
        crpDate: string,
        cprControlDigits: string,
        clientInfo: ClientInfo,
        webapiBasepath: string
    )
    {
        super(
            'upsale/ticket',
            null,
            null,
            {
                'PlayerId': playerId,
                'TicketNumber': ticketNumber,
                'TicketLetter': ticketLetter,
                'ClassCount': classCount,
                'RegNumber': regNumber,
                'AccounNumber': accountnumber,
                'CprDate': crpDate,
                'CprControlDigits': cprControlDigits,
                'referrer': clientInfo.Referrer,
                'browser': clientInfo.Browser,
                'platform': clientInfo.Platform,
                'version': clientInfo.TrackingChannel,
                'trackingChannel': clientInfo.TrackingChannel,
                'trackingChannelMetadata': clientInfo.TrackingChannelMetadata
            },
            webapiBasepath
        );

    }
}
